import { render, staticRenderFns } from "./LoanLoanableCalendar.vue?vue&type=template&id=2a615752&scoped=true"
import script from "./LoanLoanableCalendar.vue?vue&type=script&lang=js"
export * from "./LoanLoanableCalendar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a615752",
  null
  
)

export default component.exports